import React, { useRef } from "react";

interface IFileUploadInput {
  children: React.ReactNode;
  onChange: (files: FileList) => void;
  allowMultiUpload?: boolean;
  accept?: string;
}

export default function FileUploadInput({ children, onChange, allowMultiUpload = false, accept }: IFileUploadInput) {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileClick = () => {
    if (!fileInputRef.current) return;
    fileInputRef.current.click();
    fileInputRef.current.value = ""; // Reset the input value
  };

  return (
    <div className='tw-h-full tw-w-full tw-cursor-pointer' onClick={handleFileClick} role='button' tabIndex={0}>
      <input
        style={{ display: "none" }}
        ref={fileInputRef}
        type='file'
        accept={accept}
        multiple={allowMultiUpload}
        onChange={(e) => {
          if (!e.target.files) return;
          onChange(e.target.files);
        }}
      />
      {children}
    </div>
  );
}
